import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Typography, Box, IconButton, Menu, MenuItem, } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { logoutUser } from '../redux/slices/authSlice'


function Profileone() {
  const { t } = useTranslation('global');
  const settings = [{ 'lable': t('profile'), 'name': 'profile' }, { 'lable': t('logout'), 'name': 'logout' }];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleClick = (name) => {
    console.log('first name ::->', name)
    if (name === 'logout') {
      dispatch(logoutUser());
      navigate("/prelogin");
    }
    if (name === 'profile') {
      navigate("/profile");
    }
  }
  return (
    <Box sx={{
      backgroundColor: ' #028DD5',
      borderRadius: '50%', width: '45px', height: '45px', margin: '0px', display: 'flex', justifyContent: 'center'
    }}>
      <IconButton onClick={handleOpenUserMenu} sx={{ color: '#fff', p: 0 }}>
        {userInfo.firstName.charAt(0)?.toUpperCase()}{userInfo.lastName.charAt(0)?.toUpperCase()}
      </IconButton>

      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting) => (
          <MenuItem key={setting.name} onClick={handleCloseUserMenu}>
            <Typography onClick={() => handleClick(setting.name)} textAlign="center">{setting.lable}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>

  )
}

export default Profileone